import React from 'react';

import { useSoyuzClientConfig, useSoyuzLocales } from '@spotahome/soyuz/client';

import { FooterSimplified as FooterSimplifiedComponent } from '@spotahome/ui-library';

import { useLocaleChange } from '../hooks/useLocaleChange';

function handleHelpClick(e) {
  e.preventDefault();
  if (typeof zE !== 'undefined') {
    zE.activate({ hideOnClose: true });
  }
}

const FooterSimplified = () => {
  const clientConfig = useSoyuzClientConfig();
  const handleOnLocaleChange = useLocaleChange();
  const { current } = useSoyuzLocales();

  return (
    <FooterSimplifiedComponent
      theme="beige"
      localeToggle={{ chinese: clientConfig.featureToggle.chinese }}
      help={{
        onClick: handleHelpClick
      }}
      locales={{ current, onChange: handleOnLocaleChange }}
      apps={{
        android: {
          link: 'https://spotahome.app.link/android_footer_home',
          eventCategory: 'app-promotion',
          eventAction: 'footer-icon-android',
          eventLabel: 'open'
        },
        ios: {
          link: 'https://spotahome.app.link/ios_footer_home',
          eventCategory: 'app-promotion',
          eventAction: 'footer-icon-ios',
          eventLabel: 'open'
        }
      }}
    />
  );
};

export default FooterSimplified;
